import React, { useState, useEffect } from 'react';

// Components //
import TitleSection from "../../molecules/title-section";

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import { splitButtonText } from '../../../utils/helpers';

// Interface //
import { ReferenciaContenido } from 'interfaces/ReferenciaContenido';

// Styles //
import "./givenSubsidy.scss";

const GivenSubsidy = (props: ReferenciaContenido) => {
    const { tituloGeneral, etiquetasArticulo, referenciaPlantillaContenido: listHistorias } = props;
    const [activedTabs, setActivedTabs] = useState(0);

    const handleTabs = (e) => {
        const index = parseInt(e.target.id, 0);
        if (index !== activedTabs) {
            setActivedTabs(index);
        }
    };

    useEffect(() => {
        const intervalID = setInterval(() => {
            setActivedTabs((prevTab) => (prevTab + 1) % listHistorias.length)
        }, 400000);

        return () => {
            clearInterval(intervalID);
        };

    }, [activedTabs])

    return (
        <div className="o-given-subsidy">
            <div className="container">
                <div className="o-given-subsidy__inner">
                    <div className="history-box">
                        <TitleSection title={tituloGeneral}/>
                        <div className="history-box__image">
                            {listHistorias.map((item, index) => (
                                <img key={item.tituloBanner} className={`${activedTabs === index ? "active" : ""}`} src={item.imagenPrincipal[0].file.url} />
                            ))}
                            {etiquetasArticulo && (
                                <div className="history-box__image__numbers">
                                    <div>
                                        <span>{splitButtonText(etiquetasArticulo[0],0,":")}</span>
                                        <p>{splitButtonText(etiquetasArticulo[0],1,":")}</p>
                                    </div>
                                    <div>
                                        <span>{splitButtonText(etiquetasArticulo[1],0,":")}</span>
                                        <p>{splitButtonText(etiquetasArticulo[1],1,":")}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="history-box__tabs">
                            <TitleSection title={tituloGeneral}/>
                            <div className="history-box__tabs__buttons">
                                {listHistorias.map((item, index) => (
                                    <button key={item.tituloBanner} className={`${activedTabs === index ? "active" : ""}`} id={String(index)} onClick={handleTabs}>{item.tituloDescripcion}</button>
                                ))}
                            </div>
                            {listHistorias.map((item, index) => (
                                <div key={item.tituloBanner} className={`history-box__tabs__content ${activedTabs === index ? "active" : ""}`}>
                                    <h3>{item.tituloBanner}</h3>
                                    {contentfulRenderOptions(item.descripcion.json)}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GivenSubsidy